export default __webpack_public_path__ + "static/media/39.b7239eb2.jpg";